import { createSlice } from '@reduxjs/toolkit';

const alertSlice = createSlice({
  name: 'subscription',
  initialState: {
    count:null,
    limit:0,
    records:[]
  },
  reducers: {
    addSubscriptions: (state, action) => {
      return action.payload
    }
  },
});

export const { addSubscriptions } = alertSlice.actions;
export default alertSlice.reducer;
